<template>
    <DefaultTour :tour-name-key="tourNameKey"
                 :tour-steps="tourSteps"
                 :tour-available="tourAvailable" />
</template>

<script lang="js">
    import { defineComponent } from 'vue';
    import { userGuideService } from '../userGuideService'

    import DefaultTour from './DefaultTour.vue'

    export default defineComponent({
        props: {
            tourAvailable: {
                type: Boolean,
                default: false,
            }
        },
        components: {
            DefaultTour,
        },
        data() {
            return {
                tourNameKey: "updateTranslationTour.tourName",
                tourSteps: userGuideService.getUpdateTranslation(),
            };
        },
    })
</script>
